import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Waypoint } from 'react-waypoint';
import Button from '../../../Button';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import s from './ThreadPagination.scss';
const ThreadPagination = ({ hasMore , isInfinite , isFetching , onLoadMore , className , biData , direction  })=>{
    const { t  } = useTranslation();
    const logBiEvent = useBiLogger();
    const onInfiniteScroll = useCallback(()=>{
        if (!biData) {
            return;
        }
        logBiEvent(biData);
        onLoadMore();
    }, [
        biData,
        logBiEvent,
        onLoadMore
    ]);
    if (!hasMore) {
        return null;
    }
    if (isInfinite) {
        return /*#__PURE__*/ React.createElement(Waypoint, {
            topOffset: 100,
            onEnter: onInfiniteScroll
        });
    }
    if (direction !== 'next') {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['button-wrap']
        }, /*#__PURE__*/ React.createElement(GhostButton, {
            size: 'small',
            variant: 'main',
            onClick: onLoadMore,
            biData: biData,
            disabled: isFetching
        }, t('commentthread.control.loadprev')));
    }
    return /*#__PURE__*/ React.createElement(Button, {
        view: "b3",
        onClick: onLoadMore,
        biData: biData,
        disabled: isFetching,
        className: classnames(s['button'], className)
    }, direction === 'next' ? t('commentthread.control.loadmore') : t('commentthread.control.loadprev'));
};
ThreadPagination.displayName = 'ThreadPagination';
export default ThreadPagination;
